import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-display tracking-wider uppercase transition-all duration-300 ease-out rounded-sm';
  const variants = {
    primary: 'bg-brand-orange text-white hover:bg-brand-orangeHover hover:box-glow border border-transparent',
    secondary: 'bg-brand-card text-brand-text hover:bg-brand-cardHover border border-brand-border',
    outline: 'bg-transparent text-brand-orange border border-brand-orange hover:bg-brand-orange/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-lg',
    md: 'px-8 py-4 text-xl',
    lg: 'px-10 py-5 text-2xl md:text-3xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-365">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-366">
      {children}
    </button>;
}